// Auto-generated skeleton for JournalReview

import { ReviewDocumentReviewer } from "./ReviewDocumentReviewer";
import { ReviewDocument } from "./ReviewDocument";

export const JournalReview: Api.JournalReview = {
  id: 0,
  valid: false,
  reviewer_id: 0,
  journal_id: 0,
  reviewer: ReviewDocumentReviewer,
  journal: null,
  review_document: ReviewDocument,
  created: null,
  updated: null,
};

